export default {"src":"/_next/static/media/explore1.26844a47.svg","height":700,"width":1512,"blurWidth":0,"blurHeight":0};